<template>
    <Filters v-if="productStore.translations" />
    <h4 v-if="productStore.error">An error occured</h4>
    <div v-if="productStore.isLoading > 0">
      <BaseSpinner />
    </div>
    <DataTable
      v-if="productStore.searchResult !== null && productStore.selectedLanguage !== '' && productStore.selectedProduct !== '' "
    ></DataTable>
</template>

<script setup>
import { watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useProductStore } from './store/store.js';
import Filters from "./components/Filters.vue";
import DataTable from "./components/DataTable.vue";
import BaseSpinner from "./components/BaseSpinner.vue";
import {error} from "@splidejs/splide/src/js/utils";

const productStore = useProductStore();
productStore.setInitialState();

const { selectedType, selectedProduct, selectedLanguageCode } = storeToRefs(productStore)

// Watch for store updates for all three selections and when all three are set, make a search
watch([selectedType, selectedProduct, selectedLanguageCode], () => {
  if (selectedType.value, selectedProduct.value, selectedLanguageCode.value) {
    productStore.performSearch();
  }
});

</script>